import React from 'react'
import PropTypes from 'prop-types'

import './Slider.sass'

function Slider (props) {
  const { handle, min, max, step, value } = props
  return (
    <div className='variable-slider'>
      <input
        className='slider'
        step={step}
        min={min}
        max={max}
        value={value}
        onChange={event => handle(event.target.value)}
        type='range'
      />
      <div className='value'>{value}%</div>
    </div>
  )
}

Slider.propTypes = {
  handle: PropTypes.func,
  min: PropTypes.number,
  max: PropTypes.number,
  step: PropTypes.number,
  value: PropTypes.number
}

Slider.defaultProps = {
  min: 0,
  max: 30,
  step: 5,
  value: 0
}

export default Slider
